import { create } from "zustand";

const useUserProfileStore = create(set => ({
  // Profile data
  profileData: null,
  isLoading: false,
  isSuccess: false,
  error: null,

  // Actions
  setProfileLoading: () =>
    set({
      isLoading: true,
      isSuccess: false,
      error: null
    }),

  setProfileSuccess: data =>
    set({
      profileData: data,
      isLoading: false,
      isSuccess: true,
      error: null
    }),

  setProfileError: error =>
    set({
      profileData: null,
      isLoading: false,
      isSuccess: false,
      error
    }),

  resetProfile: () =>
    set({
      profileData: null,
      isLoading: false,
      isSuccess: false,
      error: null
    })
}));

export default useUserProfileStore;
